import { toggleImageTileExpansion } from './toggle-image-tile-expansion';
import { trackDimensionExpansion } from './track-dimension-expansion';

export const setupMoreColorsLink = (showMoreColorsLink: HTMLElement, imageTileContainer: HTMLElement, productId: string) => {
    showMoreColorsLink.classList.remove('pl_hidden');
    showMoreColorsLink.removeEventListener('click', () => toggleImageTileExpansion(showMoreColorsLink, imageTileContainer, productId)); // Necessary so that locally the list doesn't break after multiple variation changes
    showMoreColorsLink.addEventListener('click', () => {
        trackDimensionExpansion(showMoreColorsLink);
        toggleImageTileExpansion(showMoreColorsLink, imageTileContainer, productId);
    });
};
